export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const APP_BASE_URL = process.env.REACT_APP_APP_BASE_URL;
export const ASSETS_URL = process.env.REACT_APP_ASSETS_URL;
